var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.758 286.003C424 286.002 387 286.002 356.999 286.003H53.2412V469H477.758V286.003Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477.758 286.003C434 286.002 394.5 286.003 356.999 286.003H53.2412",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.772 159.229C241.288 159.214 228.755 156.627 207.051 149.638C194.14 142.629 163.448 136.505 143.97 168.082C136.346 182.346 125.673 220.539 143.97 259.2C152.086 274.447 167.284 309.886 163.153 329.659C158.357 354.129 155.406 404.397 181.966 409.709C187.377 411.8 200.411 408.972 209.265 380.936C214.178 363.247 227.538 334.044 249.772 332.247C272.006 334.044 285.366 363.247 290.279 380.936C299.133 408.972 312.167 411.8 317.578 409.709C344.138 404.397 341.187 354.129 336.391 329.659C332.26 309.886 347.458 274.447 355.574 259.2C373.871 220.539 363.198 182.346 355.574 168.082C336.096 136.505 305.404 142.629 292.493 149.638C270.789 156.627 258.256 159.214 249.772 159.229Z",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.772 159.229C241.288 159.214 228.755 156.627 207.051 149.638C194.14 142.629 163.448 136.505 143.97 168.082C136.346 182.346 125.673 220.539 143.97 259.2C152.086 274.447 167.284 309.886 163.153 329.659C158.357 354.129 155.406 404.397 181.966 409.709C187.377 411.8 200.411 408.972 209.265 380.936C214.178 363.247 227.538 334.044 249.772 332.247C272.006 334.044 285.366 363.247 290.279 380.936C299.133 408.972 312.167 411.8 317.578 409.709C344.138 404.397 341.187 354.129 336.391 329.659C332.26 309.886 347.458 274.447 355.574 259.2C373.871 220.539 363.198 182.346 355.574 168.082C336.096 136.505 305.404 142.629 292.493 149.638C270.789 156.627 258.256 159.214 249.772 159.229Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeDasharray: "20 30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.564 181.378C289.269 184.454 288.158 188.33 285.081 190.035C266.91 200.106 253.237 204.175 242.261 205.392C233.14 206.404 226.028 205.383 220.715 204.62C219.677 204.471 218.707 204.332 217.805 204.22C214.315 203.785 211.838 200.604 212.272 197.114C212.706 193.624 215.887 191.146 219.377 191.581C220.531 191.724 221.673 191.885 222.822 192.048C228.072 192.79 233.471 193.553 240.857 192.734C249.786 191.744 261.842 188.353 278.907 178.895C281.984 177.19 285.86 178.302 287.564 181.378Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.017 42.0757L351.267 78.4604",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M412.55 85.5698L381.326 103.597",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M293.599 53.6987L311.626 84.9228",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/치과_치아 결손.92cb651e6a9184f737b7fcc8f1877aa0.svg";
export { ForwardRef as ReactComponent };